import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Container, Table } from "react-bootstrap";
import { Authorization } from "../../Context/Authorization";
import { exportMonthlyVfcReportToExcel } from "../../utils/exportToExcel";
import Preloader from "../../shared/PreLoaders";
import "./Report.css";
const MonthlyVFCReport = () => {
  const { year, month } = useParams();
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;

  const formattedMonthYear = `${new Date(year, month - 1).toLocaleString(
    "default",
    {
      month: "long",
    }
  )} - ${year}`;

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const config = Authorization();
        const { data } = await axios.get(
          `${Api}/api/reports/monthly-vfc-report?year=${year}&month=${month}`,
          config
        );
        setReportData(data.report);
      } catch (error) {
        console.error("Failed to fetch VFC monthly report", error);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [Api]);
  return (
    <div className="mt-4">
      {loading && <Preloader loading={loading} />}
      <div className="card">
        <div className="card-body">
          <div className="row icons-list">
            <h4 className="text-center mb-3">ANNEXURE-A</h4>
            <h5 className="text-center mb-4">
              Monthly report on the functioning of VFC
            </h5>
            <div className="text-end mb-2">
              <button
                type="button"
                className="btn btn-outline-success btn-icon-text mt-3"
                onClick={() =>
                  exportMonthlyVfcReportToExcel(
                    reportData,
                    formattedMonthYear,
                    year
                  )
                }
              >
                <i className="mdi mdi-file-excel"></i> Export to Excel
              </button>
            </div>

            <div className="table-responsive">
              <Table striped bordered hover responsive size="sm">
                <thead className="text-center align-middle">
                  <tr>
                    <th rowSpan="2" className="wrap-header px-2">
                      Sl. No.
                    </th>
                    <th rowSpan="2" className="wrap-header px-3">
                      Division
                    </th>
                    <th rowSpan="2" className="wrap-header px-3">
                      Name and <br /> Year of Village
                    </th>
                    <th colSpan="2" className="wrap-header px-4 border-start">
                      VFC Meeting
                    </th>
                    <th colSpan="2" className="wrap-header px-4 border-start">
                      EC Meeting
                    </th>
                    <th rowSpan="2" className="wrap-header px-3 border-start">
                      Amount Available in <br /> VFDF as on Date (Rs)
                    </th>
                    <th rowSpan="2" className="wrap-header px-3 border-start">
                      Statutory Audit Done & <br /> Accounts Filed (Yes / No)
                    </th>
                    <th colSpan="3" className="wrap-header px-4 border-start">
                      Loan Recovery
                    </th>
                    <th rowSpan="2" className="wrap-header px-3 border-start">
                      Protection to Forests <br /> by VFC
                    </th>
                    <th colSpan="2" className="wrap-header px-4 border-start">
                      Benefit Sharing
                    </th>
                    <th rowSpan="2" className="wrap-header px-3 border-start">
                      Remarks of the CF
                    </th>
                  </tr>
                  <tr>
                    <th className="wrap-header">
                      Date of <br /> Previous Meeting
                    </th>
                    <th className="wrap-header">
                      Date of <br /> Latest Meeting
                    </th>

                    <th className="wrap-header">
                      No. of <br /> EC Meetings Held
                    </th>
                    <th className="wrap-header">
                      Date of <br /> Latest EC Meeting
                    </th>

                    <th className="wrap-header">
                      Department <br /> Loan Given
                    </th>
                    <th className="wrap-header">
                      % of <br /> Recovery
                    </th>
                    <th className="wrap-header">
                      Amount <br /> Revolved
                    </th>

                    <th className="wrap-header">
                      Whether <br /> NTFP Shared
                    </th>
                    <th className="wrap-header">
                      Value of <br /> Product Shared
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {reportData
                    .sort((a, b) => a.division.localeCompare(b.division))
                    .map((row, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{row.division || "-"}</td>
                        <td className="text-center">
                          {row.villageNameYear || "-"}
                        </td>
                        <td className="text-center">
                          {row.previousMeetingDate
                            ? new Date(
                              row.previousMeetingDate
                            ).toLocaleDateString("en-IN")
                            : "-"}
                        </td>
                        <td className="text-center">
                          {row.latestMeetingDate
                            ? new Date(
                              row.latestMeetingDate
                            ).toLocaleDateString("en-IN")
                            : "-"}
                        </td>
                        <td>{row.ecMeetingCount ?? "-"}</td>
                        <td className="text-center">
                          {row.latestEcMeetingDate
                            ? new Date(
                              row.latestEcMeetingDate
                            ).toLocaleDateString("en-IN")
                            : "-"}
                        </td>
                        <td>
                          {row.vfdfBalance?.toLocaleString("en-IN") ?? "-"}
                        </td>
                        <td className="text-center">
                          {row.auditStatus ? "Yes" : "No"}
                        </td>
                        <td>
                          {row.deptLoanAmount?.toLocaleString("en-IN") ?? "-"}
                        </td>
                        <td className="text-center">
                          {row.deptRecoveryPercent ?? "-"}%
                        </td>
                        <td>
                          {row.revolvingLoanAmount?.toLocaleString("en-IN") ??
                            "-"}
                        </td>
                        <td>{row.protectionStatus || "-"}</td>
                        <td className="text-center">
                          {row.ntfpShared ? "Yes" : "No"}
                        </td>
                        <td>
                          {row.ntfpSharedValue?.toLocaleString("en-IN") ?? "-"}
                        </td>
                        <td className="text-center">{row.cfRemarks || "-"}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .wrap-header {
          white-space: normal;
          word-wrap: break-word;
          min-width: 100px;
        }
      `}</style>
    </div>
  );
};

export default MonthlyVFCReport;
